var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsGpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    rx: 54,
    fill: "url(#paint0_linear_644_4426)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3564 34.3784L48.8457 73.9526C50.2284 77.2712 54.9298 77.2712 56.3125 73.9526L72.8018 34.3784",
    stroke: "url(#paint1_linear_644_4426)",
    strokeWidth: 14.9211,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_644_4426",
    x1: 54,
    y1: 0,
    x2: 54,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_644_4426",
    x1: 52.5791,
    y1: 34.3784,
    x2: 52.5791,
    y2: 82.9128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8861D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC360E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsGpt);
export default __webpack_public_path__ + "static/media/products_gpt.af83679f84e3ef2f1ceaf8e6a10f4c42.svg";
export { ForwardRef as ReactComponent };